// import "core-js";
import 'core-js'
import "regenerator-runtime/runtime";
import Vue from "vue";
import './style.css'
import "./assets/css/aui-pc.css";
import "./assets/css/customize_city.less";
import App from './App.vue'
import router from "./router";
import VueSeamlessScroll from "vue-seamless-scroll";
import ajax from "./assets/js/axios/index";
import VueErrorPlugin from './assets/js/errorTracker';
import mirror from "./assets/js/mirror.js";
import { isIE } from "./assets/js/utils";
import dgAlert from "./components/dg-alert";
import dgUI from "./components/index";

const bus = new Vue();
// 把bus挂载到了Vue的原型上, 保证所有的组件都能通过 this.$bus访问到事件总线
Vue.prototype.$bus = bus;

window.Mirror = mirror;
window.config = process.config;
Vue.prototype.ENV = process.config.env;
Vue.prototype.conf = process.config;
Vue.prototype.isIE = isIE();
window.ajax = ajax;
Vue.use(dgUI);

Vue.use(VueSeamlessScroll);
Vue.use(VueErrorPlugin, {
  reportUrl: `${window.location.origin}/webReport`,
  appId: process.config.env.SENTRY_ID, // 测试 id,
  immediate: false,
  extraData: {
    env: process.config.env.NODE_ENV,
    city: process.config.city,
    version: process.config.version
  }
});

window.fixOpen = function (url, windowName = '_blank', windowFeatures = '') {
  let newWindow = null;
  // 尝试直接打开
  try {
    newWindow = window.open(url, windowName, windowFeatures);
  } catch (e) {
    console.log(e);
  }
  // 检查是否被阻止
  if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
    //（解决IE阻止问题）

    window.ELEMENT.MessageBox.alert(`
      <div class="py-[20] text-center">
        <span class="t-[14]">受浏览器默认限制，请点击按钮继续流程</span>
      </div>
      <div>
      <a href="${url}" target="${windowName}" class="block mx-[auot]">
        <button data-v-a469213e="" type="button" class="el-button el-button--primary el-button--small">
        <span>立即前往<i data-v-a469213e="" class="el-icon-arrow-right pl-4"></i></span>
        </button>
        </a>
      </div>
          `,
      '跳转提示', {
      center: true,
      showConfirmButton: false,
      dangerouslyUseHTMLString: true
    });
  }
  return newWindow;
};

/**
 * 动态引入js
 */
let injectScript = (srcs, callback) => {
  let loadNextScript = (index) => {
    if (index >= srcs.length) {
      return;
    }
    let s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = srcs[index];
    let t = document.getElementsByTagName("script")[0];
    t.parentNode.insertBefore(s, t);
    s.onload = function () {
      callback && callback();
    };
  };

  // 开始加载第一个脚本
  loadNextScript(0);
};

window.Vue = Vue;

injectScript(['index.js'], () => {
  Vue.use(dgAlert);
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app');

});